import React, { useContext } from 'react';
import Fade from 'react-reveal/Fade';
import { ThemeContext } from '../../contexts/ThemeContext';

import './Experience.css';

function ExperienceCard({
  company,
  role,
  duration,
  tech,
  domain,
  description,
}) {
  const { theme } = useContext(ThemeContext);

  return (
    <Fade bottom>
      <div
        className="timeline-card"
        style={{
          background: theme.primary30,
          borderLeft: `4px solid ${theme.primary}`,
        }}
      >
        <div className="timeline-top">
          <div>
            <h3 style={{ color: theme.tertiary }}>{company}</h3>
            <h4 style={{ color: theme.primary }}>{role}</h4>
          </div>

          <span
            className="timeline-duration"
            style={{
              background: theme.primary,
              color: theme.secondary,
            }}
          >
            {duration}
          </span>
        </div>

        <p
          className="timeline-domain"
          style={{ color: theme.tertiary80 }}
        >
          {domain}
        </p>

        <p
          className="timeline-description"
          style={{ color: theme.tertiary70 }}
        >
          {description}
        </p>

        <div className="timeline-tech">
          {tech.map((item, index) => (
            <span
              key={index}
              className="tech-chip"
              style={{
                background: theme.primary50,
                color: theme.tertiary,
              }}
            >
              {item}
            </span>
          ))}
        </div>
      </div>
    </Fade>
  );
}

export default ExperienceCard;